import { Link } from "react-router-dom";
import { classList } from "../../utils";

function SellAdmissionForm() {
  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mt-2 pt-1 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">Sell Admission Form</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Fees Collection</a>
                          </li>
                          <li class="breadcrumb-item">
                            <a href="#">Admission Form</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            Sell Admission Form
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3">
            <div class="container-fluid">
              <div className="row g-2">
                <div className="col-lg-8">
                  <div class="px-5 py-3 bg-white rounded-4">
                    <div
                      class="accordion accordion-flush"
                      id="accordionExample"
                    >
                      <div id="headingOne">
                        <h3 class="m-0 fs-list">
                          <a
                            href="#"
                            class="d-flex align-items-center text-inherit"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-controls="collapseOne"
                          >
                            <span class="me-auto fs-5">
                              1. Form Details{" "}
                              <span className="ms-3 text-secondary">
                                (01/07)
                              </span>
                            </span>
                            <div className="d-flex align-items-center">
                              <span className="collapse-toggle">
                                <i class="bi bi-chevron-down"></i>
                              </span>
                            </div>
                          </a>
                        </h3>

                        <div
                          id="collapseOne"
                          class="collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="row g-2 mt-2 mb-3">
                            <div className="col-lg-6 col-12">
                              <label class="form-label mb-1 ms-3">
                                Receipt Date{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control text-dark"
                                placeholder="..."
                                value={new Date().toLocaleDateString("en-GB")}
                                readOnly
                                required
                              />
                            </div>
                            <div className="col-lg-6 col-12">
                              <label class="form-label mb-1 ms-3">
                                Form Number
                              </label>
                              <input
                                type="text"
                                class="form-control text-dark"
                                placeholder="..."
                                required
                                readOnly
                              />
                            </div>
                            <div className="col-lg-6 col-12">
                              <label class="form-label mb-1 ms-3">
                                Student Name{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control text-dark"
                                placeholder="..."
                                required
                              />
                            </div>
                            <div className="col-lg-6 col-12">
                              <label class="form-label mb-1 ms-3">
                                Class <span className="text-danger">*</span>
                              </label>
                              <select className="form-control">
                                <option value="">...</option>
                                {classList.map((className, index) => (
                                  <option key={index} value={className}>
                                    {className}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-lg-6 col-12">
                              <label class="form-label mb-1 ms-3">
                                Select Gender{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <select className="form-control">
                                <option value="">...</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="px-5 py-3 mt-1 bg-white rounded-4">
                    <div
                      class="accordion accordion-flush"
                      id="accordionExample"
                    >
                      <div id="headingTwo">
                        <h3 class="m-0 fs-list">
                          <a
                            href="#"
                            class="d-flex align-items-center text-inherit"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-controls="collapseTwo"
                          >
                            <span class="me-auto fs-5">
                              2. Parent Details{" "}
                              <span className="ms-3 text-secondary">
                                (02/04)
                              </span>
                            </span>
                            <div className="d-flex align-items-center">
                              <span className="collapse-toggle">
                                <i class="bi bi-chevron-down"></i>
                              </span>
                            </div>
                          </a>
                        </h3>

                        <div
                          id="collapseTwo"
                          class="collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="row g-2 mt-2 mb-3">
                            <div className="col-lg-6 col-12">
                              <label class="form-label mb-1 ms-3">
                                Father Name{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control text-dark"
                                placeholder="..."
                                required
                              />
                            </div>

                            <div className="col-lg-6 col-12">
                              <label class="form-label mb-1 ms-3">
                                Mobile No <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control text-dark"
                                placeholder="..."
                                required
                              />
                            </div>
                            <div className="col-lg-6 col-12">
                              <label class="form-label mb-1 ms-3">
                                Address <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control text-dark"
                                placeholder="..."
                                required
                              />
                            </div>
                            <div className="col-lg-6 col-12">
                              <label class="form-label mb-1 ms-3">
                                Email ID <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                class="form-control text-dark"
                                placeholder="..."
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div class="p-5 bg-white rounded-4 sticky-top top-10 z-1">
                    <div className="d-flex flex-column align-items-center">
                      <div className="mt-1 text-center">
                        <h3 class="m-0 fs-4 lh-sm">Abhishek Singh</h3>
                        <p className="m-0">4578, 18/01/2025</p>

                        <div>
                          <img
                            src="https://cdn-icons-png.flaticon.com/512/5790/5790705.png"
                            width="80"
                            className="mt-3"
                          />
                        </div>

                        <p className="mt-1 mb-0">Total Payable</p>
                        <h3 class="m-0 lh-sm h2">
                          <i className="bi bi-currency-rupee"></i>800
                        </h3>

                        <div className="d-flex flex-wrap justify-content-center mt-4">
                          <span class="badge bg-secondary-soft rounded-pill me-1 mb-1 px-3">
                            Cash
                          </span>
                          <span class="badge bg-secondary-soft rounded-pill me-1 mb-1 px-3">
                            UPI
                          </span>
                          <span class="badge bg-secondary-soft rounded-pill me-1 mb-1 px-3">
                            NEFT
                          </span>
                          <span class="badge bg-secondary-soft rounded-pill me-1 mb-1 px-3">
                            Cheque
                          </span>
                          <span class="badge bg-secondary-soft rounded-pill me-1 mb-1 px-3">
                            Card Swap
                          </span>
                          <span class="badge bg-secondary-soft rounded-pill me-1 mb-1 px-3">
                            Net Banking
                          </span>
                        </div>

                        <div className="mt-3">
                          <a href="#" class="btn btn-danger btn-sm px-4 rounded-3 px-3">
                            Confirm Payment
                          </a>
                        </div>

                        <p className="mb-1 text-secondary mt-3 lh-sm">
                          (+91) 9988776655
                          <br />
                          abhishek78950@gmail.com
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default SellAdmissionForm;
